module.exports = __webpack_public_path__ + "img/logo.7b4a3cf0.png";